export const iqcLocaleData: Record<string, Record<string, string>> = {
  'zh-tw': {
    'iqc.title.1': '準備好成為下一個',
    'iqc.title.2': '量化金融研究贏家',
    'iqc.title.3': '了嗎?',
    'iqc.subtitle2': '探索量化金融的世界並報名由WorldQuant BRAIN所舉辦的International Quant Championship (全球量化金融研究錦標賽)',
    'iqc.firstNameLabel': '英文姓名',
    'iqc.lastNameLabel': '英文姓氏',
    'iqc.registerButton': '立即註冊',
    'iqc.opportunityTitle': '比賽機會',
    'iqc.opportunityText': '表現優秀的參賽者可能有資格獲得以下機會:\u002A',
    'iqc.opportunityListItem1': '總獎金<highlight>100,000</highlight>美元的現金獎勵',
    'iqc.opportunityListItem2': 'BRAIN 研究顧問職位',
    'iqc.opportunityListItem3': '全職BRAIN研究員與實習職位',
    'iqc.opportunityListItem4': '表現優秀隊伍將有機會被邀請參加預計於2026年9月在新加坡舉行的全球總決賽',
    'iqc.opportunityExtra': '\u002A請參閱官方規則獲得更多資訊。',
    'iqc.resourcesTitle': '比賽資源',
    'iqc.resourcesText1': `報名線上培訓課程： 
<linkIQCWebinarEnglish>英語</linkIQCWebinarEnglish>、 
<linkIQCWebinarKorean>韓語</linkIQCWebinarKorean>、 
<linkIQCWebinarSimplifiedChinese>簡體中文</linkIQCWebinarSimplifiedChinese>、 
<linkIQCWebinarTraditionalChinese>繁體中文</linkIQCWebinarTraditionalChinese>、 
<linkIQCWebinarThai>泰語</linkIQCWebinarThai>以及
<linkIQCWebinarVietnamese>越南語</linkIQCWebinarVietnamese>。`,
    'iqc.resourcesText2': `欲了解更多有關WorldQuant BRAIN的全球量化金融研究錦標賽，請點擊<linkIQCWorldquant>這裡</linkIQCWorldquant>。`,
    'iqc.signUpForIQCButton': '報名IQC',
    'iqc.openCompetitionButton': '馬上報名',
    'iqc.headerTitle': 'International Quant Championship',
    'iqc.shareOn': '分享IQC 2026',
    'iqc.lastIQCHighlightsTitle': 'IQC 2025 精彩花絮',
    'iqc.registrationWillOpen': '<strong>{formattedStartDate}</strong>開放註冊.',
    'countdown.days': '日',
    'countdown.hours': '小時',
    'countdown.minutes': '分',
    'countdown.seconds': '秒',
  },
  'zh-cn': {
    'iqc.title.1': '下一个全球',
    'iqc.title.2': '量化挑战赛冠军',
    'iqc.title.3': '是你吗？',
    'iqc.subtitle2': '进入量化金融的世界，报名参加WorldQuant BRAIN全球量化挑战赛。',
    'iqc.firstNameLabel': '名',
    'iqc.lastNameLabel': '姓',
    'iqc.registerButton': '立即注册',
    'iqc.opportunityTitle': '机会',
    'iqc.opportunityText': '表现优秀的参赛者可能有资格获得以下机会\u002A',
    'iqc.opportunityListItem1': '获得现金奖励，比赛总奖金池为<highlight>100,000</highlight>美元',
    'iqc.opportunityListItem2': '成为BRAIN研究顾问',
    'iqc.opportunityListItem3': '成为BRAIN全职研究员和实习生',
    'iqc.opportunityListItem4': '表现优秀的参赛者还可能被邀请参加预计于2025年9月在新加坡举行的全球总决赛',
    'iqc.opportunityExtra': '\u002A请参阅官方指南了解所有规则。',
    'iqc.resourcesTitle': '资源',
    'iqc.resourcesText1': `点此注册我们的网络研讨会系列： 
<linkIQCWebinarEnglish>英语</linkIQCWebinarEnglish>, 
<linkIQCWebinarKorean>韩语</linkIQCWebinarKorean>, 
<linkIQCWebinarSimplifiedChinese>简体中文</linkIQCWebinarSimplifiedChinese>, 
<linkIQCWebinarTraditionalChinese>繁体中文</linkIQCWebinarTraditionalChinese>,
<linkIQCWebinarThai>泰语</linkIQCWebinarThai>和
<linkIQCWebinarVietnamese>越南语</linkIQCWebinarVietnamese>。`,
    'iqc.resourcesText2': `想了解更多关于WorldQuant BRAIN的全球量化挑战赛，<linkIQCWorldquant>点击此处</linkIQCWorldquant>。`,
    'iqc.signUpForIQCButton': '点击注册IQC',
    'iqc.openCompetitionButton': '现在报名',
    'iqc.headerTitle': 'International Quant Championship',
    'iqc.shareOn': '在',
    'iqc.shareOn.suffix': '上分享IQC 2026',
    'iqc.lastIQCHighlightsTitle': 'IQC 2025回顾',
    'iqc.registrationWillOpen': '<strong>{formattedStartDate}</strong>开放注册.',
    'countdown.days': '天',
    'countdown.hours': '时',
    'countdown.minutes': '分',
    'countdown.seconds': '秒',
  },
  vi: {
    'iqc.subtitle2':
      'Bứt phá vào thế giới Tài chính Định lượng và đăng ký tham gia cuộc thi International Quant Championship của WorldQuant BRAIN.',
    'iqc.firstNameLabel': 'Tên',
    'iqc.lastNameLabel': 'Họ',
    'iqc.registerButton': 'Đăng ký ngay',
    'iqc.opportunityTitle': 'Các cơ hội',
    'iqc.opportunityText': 'Các thí sinh có thành tích tốt có thể sẽ đủ điều kiện để nhận được các cơ hội như:\u002A',
    'iqc.opportunityListItem1': 'Phần thưởng tiền mặt với tổng trị giá lên đến <highlight>100,000 USD</highlight>',
    'iqc.opportunityListItem2': 'Vị trí BRAIN Research Consultant',
    'iqc.opportunityListItem3': 'Các vị trí BRAIN Researcher chính thức và thực tập',
    'iqc.opportunityListItem4':
      'Các thí sinh có thành tích xuất sắc nhất có thể sẽ được mời tham dự vòng Chung kết Quốc tế dự kiến tổ chức tại Singapore vào tháng 9 năm 2026',
    'iqc.opportunityExtra':
      '\u002AVui lòng tham khảo các quy định của cuộc thi trong <linkIQCGuidelines>hướng dẫn chính thức</linkIQCGuidelines>.',
    'iqc.resourcesTitle': 'Tìm hiểu thêm',
    'iqc.resourcesText1': `Đăng ký tham gia các chuỗi webinar tại đây: 
<linkIQCWebinarEnglish>tiếng Anh</linkIQCWebinarEnglish>, 
<linkIQCWebinarKorean>tiếng Hàn</linkIQCWebinarKorean>, 
<linkIQCWebinarSimplifiedChinese>tiếng Trung (giản thể)</linkIQCWebinarSimplifiedChinese>, 
<linkIQCWebinarTraditionalChinese>tiếng Trung (phồn thể)</linkIQCWebinarTraditionalChinese>,
<linkIQCWebinarThai>tiếng Thái</linkIQCWebinarThai> 
và <linkIQCWebinarVietnamese>tiếng Việt</linkIQCWebinarVietnamese>.`,
    'iqc.resourcesText2': `Tìm hiểu thêm về cuộc thi International Quant Championship của WorldQuant BRAIN <linkIQCWorldquant>tại đây</linkIQCWorldquant>.`,
    'iqc.signUpForIQCButton': 'Đăng ký ngay',
    'iqc.openCompetitionButton': 'Tham gia ngay',
    'iqc.headerTitle': 'International Quant Championship',
    'iqc.shareOn': 'Chia sẻ về IQC 2026 trên',
    'iqc.lastIQCHighlightsTitle': 'Điểm nhấn IQC 2025',
    'iqc.registrationWillOpen': 'Thời gian đăng ký bắt đầu từ <strong>{formattedStartDate}</strong>.',
    'countdown.days': 'Ngày',
    'countdown.hours': 'Giờ',
    'countdown.minutes': 'Phút',
    'countdown.seconds': 'Giây',
  },
  ko: {
    'iqc.title.1': '2026 국제',
    'iqc.title.2': '퀀트 챔피언',
    'iqc.title.3': '을 찾아라!',
    'iqc.subtitle2': 'WorldQuant가 주최하는 International Quant Championship (IQC) 대회에 참가해 세계 퀀트 챔피언에 도전해 보세요!',
    'iqc.firstNameLabel': '이름',
    'iqc.lastNameLabel': '성',
    'iqc.registerButton': 'BRAIN 플랫폼 가입하기',
    'iqc.opportunityTitle': '대회 특전',
    'iqc.opportunityText': '우수 참가자분들에게는 다음과 같은 혜택이 주어질수 있습니다\u002A:',
    'iqc.opportunityListItem1': '총 상금 <highlight>10만달러</highlight>',
    'iqc.opportunityListItem2': 'BRAIN 리서치 컨설턴트가 될 수 있는 기회',
    'iqc.opportunityListItem3': '정규직 BRAIN 리서처 및 인턴십 채용의 기회',
    'iqc.opportunityListItem4': '국가대표팀으로 선발시 2026년 9월 싱가포르에서 열리는 국제결승전 참가권',
    'iqc.opportunityExtra': '\u002A<linkIQCGuidelines>공식 대회 규정</linkIQCGuidelines>을 참고하세요.',
    'iqc.resourcesTitle': 'Resources',
    'iqc.resourcesText1': `대회 참가자들에게 특별히 제공되는 무료 퀀트투자 강의를 지금 등록하세요:
<linkIQCWebinarEnglish>English</linkIQCWebinarEnglish>, 
<linkIQCWebinarKorean>Korean</linkIQCWebinarKorean>, 
<linkIQCWebinarSimplifiedChinese>Simplified Chinese</linkIQCWebinarSimplifiedChinese>, 
<linkIQCWebinarTraditionalChinese>Traditional Chinese</linkIQCWebinarTraditionalChinese>, 
<linkIQCWebinarThai>Thai</linkIQCWebinarThai> and 
<linkIQCWebinarVietnamese>Vietnamese</linkIQCWebinarVietnamese>.`,
    'iqc.resourcesText2': `WorldQuant BRAIN이 주관하는 International Quant Championship 대회에 대한 더 자세한 내용은 <linkIQCWorldquant>여기</linkIQCWorldquant>에서 확인하실 수 있습니다.`,
    'iqc.signUpForIQCButton': 'IQC 대회에 등록하기',
    'iqc.openCompetitionButton': '지금 등록하세요',
    'iqc.headerTitle': 'International Quant Championship',
    'iqc.shareOn': '2026 IQC 소식을 친구들과 공유하기',
    'iqc.lastIQCHighlightsTitle': 'IQC 2025 하이라이트',
    'iqc.registrationWillOpen': '대회 등록은 <strong>{formattedStartDate}</strong>부터 시작됩니다.',
    'countdown.days': '일',
    'countdown.hours': '시간',
    'countdown.minutes': '분',
    'countdown.seconds': '초',
  },
  en: {
    'iqc.title.1': 'Are you the next',
    'iqc.title.2': 'quant champion?',
    'iqc.subtitle2': "Break into the world of quantitative finance and sign up for WorldQuant BRAIN's International Quant Championship.",
    'iqc.firstNameLabel': 'First Name',
    'iqc.lastNameLabel': 'Last Name',
    'iqc.registerButton': 'Sign up now',
    'iqc.opportunityTitle': 'The Opportunity',
    'iqc.opportunityText': 'Participants who perform well may be eligible for the following opportunities:\u002A',
    'iqc.opportunityListItem1': 'Cash prizes from a pool of <highlight>US$100,000</highlight>',
    'iqc.opportunityListItem2': 'BRAIN Research Consultant positions',
    'iqc.opportunityListItem3': 'Full-time BRAIN researcher roles and internships',
    'iqc.opportunityListItem4':
      'Top performers may also be invited to compete in the global finals expected to be held in Singapore in September 2026',
    'iqc.opportunityExtra': '\u002APlease refer to <linkIQCGuidelines>the official guidelines</linkIQCGuidelines> for all rules.',
    'iqc.resourcesTitle': 'Resources',
    'iqc.lastIQCHighlightsTitle': 'IQC 2025 Highlights',
    'iqc.resourcesText1': `Register for our webinar series here:
<linkIQCWebinarEnglish>English</linkIQCWebinarEnglish>,
<linkIQCWebinarEnglishSGMY>English (Singapore/Malaysia)</linkIQCWebinarEnglishSGMY>,
<linkIQCWebinarKorean>Korean</linkIQCWebinarKorean>,
<linkIQCWebinarSimplifiedChinese>Simplified Chinese</linkIQCWebinarSimplifiedChinese>,
<linkIQCWebinarTraditionalChinese>Traditional Chinese</linkIQCWebinarTraditionalChinese>,
<linkIQCWebinarThai>Thai</linkIQCWebinarThai> and
<linkIQCWebinarVietnamese>Vietnamese</linkIQCWebinarVietnamese>.`,
    'iqc.resourcesText2': `To learn more about WorldQuant BRAIN’s International Quant Championship, <linkIQCWorldquant>click here</linkIQCWorldquant>.`,
    'iqc.signUpForIQCButton': 'Sign Up for IQC',
    'iqc.openCompetitionButton': 'Enroll Now',
    'iqc.headerTitle': 'International Quant Championship',
    'iqc.share.facebookQuote': "Join me on the WorldQuant BRAIN's International Quant Championship 2026, a quant finance competition",
    'iqc.share.facebookHashtag': '#IQC2026',
    'iqc.share.linkedinTitle': "WorldQuant BRAIN's International Quant Championship 2026",
    'iqc.share.linkedinSummary': "Break into the world of quant finance with WorldQuant BRAIN's International Quant Championship 2026",
    'iqc.share.linkedinSource': 'WorldQuant BRAIN',
    'iqc.registrationWillOpen': 'The registration will open on <strong>{formattedStartDate}</strong>.',
    'iqc.shareOn': 'Share IQC 2026 on',
    'iqc.copyrightText': 'Copyright © {year} VirtualResearchCenterLLC. All rights reserved.',
    'countdown.days': 'Days',
    'countdown.hours': 'Hours',
    'countdown.minutes': 'Minutes',
    'countdown.seconds': 'Seconds',
  },
};
